import React from "react";

export default function Navbar() {
  return <div className="text-center text-5xl mt-4">Quote Generator</div>;
}
